import { Box, Typography } from '@mui/material';

export const PageHeader = ({ title, subtitle, action }) => (
  <Box display="flex" alignItems="flex-start" justifyContent="space-between" mb={3} flexWrap="wrap" gap={2}>
    <Box>
      <Typography variant="h5" fontWeight={700} fontFamily="'Sora',sans-serif" color="text.primary">
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" mt={0.5}>{subtitle}</Typography>
      )}
    </Box>
    {action && <Box>{action}</Box>}
  </Box>
);
